<template>
    <el-card>
        <el-page-header @back="close" content="有赞应用信息"></el-page-header>
        <el-row>
            <el-col :span="12" :offset="3">
                <el-form ref="form" :model="form" :rules="rules" :status-icon="true" label-width="100px">
                    <el-form-item label="应用名" prop="name">
                        <el-input v-model="form.name" maxlength="10" show-word-limit style="width: 300px"></el-input>
                    </el-form-item>
                    <el-form-item label="ClientId" prop="clientId">
                        <el-input v-model="form.clientId" show-word-limit style="width: 300px"></el-input>
                    </el-form-item>
                    <el-form-item label="clientSecret" prop="clientSecret">
                        <el-input v-model="form.clientSecret" show-word-limit style="width: 300px"></el-input>
                    </el-form-item>
                    <el-form-item label="appId" prop="appId">
                        <el-input v-model="form.appId" maxlength="32" show-word-limit style="width: 300px"></el-input>
                    </el-form-item>
                    <el-form-item label="sinoAppId" prop="sinoAppId">
                        <el-input v-model="form.sinoAppId" maxlength="32" show-word-limit style="width: 300px"></el-input>
                    </el-form-item>
                    <el-form-item label="租户管理员" prop="roles">
                        <el-select v-model="form.tenant" :multiple="false" style="width: 400px">
                            <el-option v-for="item in tenant" :key="item.id+''" :label="item.alias" :value="item.id+''"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click="close">取消</el-button>
                        <el-button type="primary" @click="submit">提交</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
    </el-card>
</template>

<script>

    export default {
        components: {
        },
        props: ["id"],
        data() {
            return {
                form: {
                    roles: [],
                    status: "ENABLE"
                },
                rules: {
                    name: [
                        {required: true, message: '请输入用户名'},
                        {min: 5, max: 10, message: '长度在 5 到 10 个字符'}
                    ],
                    clientSecret: [
                        {required: true}
                    ],
                    clientId: [
                        {required: true}
                    ],
                    type: [
                        {required: true, message: "请选择用户类型"},
                    ],
                },
                tenant: [],
                dataSource: [],

            };
        },
        beforeMount() {
          this.$axios.post("/user/list").then(response => {
            this.tenant = response.data;
          });
          if (this.id > 0) {
              this.$axios.get("/youzanApp/get/" + this.id).then(response => {
                  let data = response.data;
                  this.form = data;
              });
          }

        },
        methods: {
            submit() {
                let url = this.form.id ? "/youzanApp/edit" : "/youzanApp/save";

                this.$utils.submit(this.$refs.form, url, this.form, () => {
                    this.$emit("close", true);
                });
            },
            close() {
                this.$emit("close", false);
            },
        },
    }
</script>